const random = (min: number, max: number) => Math.random() * (max - min) + min;

export const generateInterval = (counter: number, cap = 15000, min = 300, base = 300) => {
  const expo = Math.min(cap, 2 ** counter * base);
  return Number(random(min, expo).toFixed(0));
};
